module.exports = __webpack_public_path__ + "static/img/HigheredEFMD.46d9860b.png";